<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header">
            <div class="modal-title">
              <span>이름 수정</span>
            </div>
            <div class="close">
              <i class="fal fa-times fa-fw" @click="closeModal"></i>
            </div>
          </slot>
        </div>
        <div class="modal-body">
          <div class="content">
            <FormulateForm #default="{ hasErrors }">
              <div>
                <div>기존</div>
                <FormulateInput type="text" :value="name" disabled />
              </div>
              <div>
                <div>신규</div>
                <FormulateInput
                  type="text"
                  v-model.trim="newName"
                  placeholder="이름"
                  autocomplete="off"
                  error-behavior="value"
                  :validation="[['between', 2, 255], ['nameValidation']]"
                  @keyup.enter="!hasErrors && submit"
                />
              </div>
              <div class="btn-wrap">
                <button v-show="!loading" @click="submit" :disabled="hasErrors">
                  수정 완료
                </button>
                <button v-show="loading" disabled>
                  <i class="far fa-spinner fa-spin fa-fw"></i>
                </button>
              </div>
            </FormulateForm>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./../ModalCommon.css" scoped></style>
<style src="@/components/common/Table/index.css"></style>
<style src="./index.css" scoped></style>

<script>
/* eslint-disable */
export default {
  components: {},
  watch: {},
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },

    async submit() {
      this.loading = true;

      const nameChangeUrlByType =
        this.$store.getters["auth/tokenPayload"]().type === "member"
          ? "users/biz_member_change_name"
          : "users/biz_manager_change_name";

      this.$store
        .dispatch(nameChangeUrlByType, { name: this.newName })
        .then((result) => {
          if (result.success) {
            alert("이름 변경이 완료되었습니다.");
            this.closeModal();
            this.$router.go();
          } else {
            const errorMessages = {
              400: "올바르지않은 요청입니다.[400]",
              401: "올바르지않은 요청입니다.[401]",
              500: "에러가 발생하였습니다.[500]"
            };

            const alertMessage =
              errorMessages[result.code] ||
              `에러가 발생하였습니다.[${result.code}]`;
            alert(alertMessage);
          }
        })
        .catch((e) => {
          console.error(e);
          this.$store.dispatch("auth/signout");
          this.$router.push("/");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  data() {
    return {
      loading: false,
      newName: ""
    };
  },
  computed: {},

  async mounted() {},
  props: {
    name: String
  }
};
</script>
